export type LookInsidePage = {
  src: string
  caption: string
}

/** Real pages from Volume 4 (9:16, 1125×2000), in display order. */
export const lookInsidePages: LookInsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nN8TA3fKsx13CjLqtqRj5c/acro-vol4-1-portada.jpg',
    caption: '6 volumes. 60 ready-to-teach sessions.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wRNyMhKRvbSfbWBrGyM6LH/acro-vol4-2-candlestick-3-lanes.jpg',
    caption: 'Every skill in 3 lanes: Ground, Lift and Fly.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nL3RYtHUtqbVwa8xavEfL9/acro-vol4-3-inversion-readiness-gate.jpg',
    caption: 'Named safety frameworks before anyone goes upside down.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/45Xf8hnD5GVSPaeT5K1WrH/acro-vol4-4-session-card-mixed-room.jpg',
    caption: 'Session cards with room maps, timings and scripts.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3au7vJDBSyaUF6mc64jJwy/acro-vol4-5-field-card.jpg',
    caption: 'Printable field cards for quick access in class.',
  },
]
